import { m } from '../../motif/m';

export const snapStatsFontVars = {
  '--stats-font-weight': '600',
  '--stats-font-size': '72px',
  '--stats-font-line-height': '70%',
  '--stats-supplementary-text-font-size': '48px',
  '--stats-supplementary-text-font-weight': '600',
  '--stats-stat-color': m('--fg-color'),
} as const;
